/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var requireServer = require('./require-server'),
  authentication = requireServer('../../middleware/authentication'),
  jsonPayload = require('../client/json-payload'),
  secretsClient = requireServer('../server/clients/secrets-client');

/*
 * A function that provides context information for a given page or request. e.g. who the logged in user is.
 * Uses the session on the server, and the context payload script on the client.
 */

module.exports = function (req) {
  if (req) {
    var context = {
      cdnDomain: req.cdnDomain,
      consoleUrl: req.consoleUrl,
      csrfToken: req.csrfToken(),
      isAutomatedTest: req.isAutomatedTest,
      lang: req.lang,
      locale: req.locale,
      enableRg: req.enableRg,
      enableYmlPreprocessor: req.enableYmlPreprocessor,
      envId: req.envId,
      nonce: req.nonceId,
      serverTime: Date.now(),
      uiVersion: req.uiVersion,
      viaConsole: req.viaConsole,
      enableSecretPicker: req.enableSecretPicker,
      enableSecretDtc: req.enableSecretDtc,
      secretRegExs: secretsClient && secretsClient.getRegEx(secretsClient.ANY_REFERENCE_TYPE),
      enableOptionalAuthorize: req.enableOptionalAuthorize,
      enableSetupWizard: req.enableSetupWizard,
      enableComplianceTemplates: req.enableComplianceTemplates,
      enableRegionSwitcher: req.enableRegionSwitcher,
      enableFSCloudDialog: req.enableFSCloudDialog
    };
    var sessionId = authentication.getSessionId(req);
    if (sessionId) {
      context.sessionId = sessionId;
    }
    if (req.user) {
      context.user = {
        iam_id: authentication.getIAMId(req),
        user_id: authentication.getIAMId(req),
        // for backward compatibility with bm-helper
        user_name: authentication.getUserName(req),
        email: authentication.getUserEmail(req),
        name: authentication.getUserName(req)
      };
    }
    return context;
  }
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && jsonPayload.get('context');
};